export class SaleListModel {
  id: string;
  number: string;
  participants: number;
  admin: string;
  customer: string;
}

export class getSaleListInput {
  tourId: string;
  params: {
    page: number;
    limit?: number;
    q?: string;
  };
}
